/**
 * Custom App Categories Service
 *
 * API calls for user-owned custom app category management.
 */

import { apiClient, ApiResponse } from './api';
import type {
  UserCustomAppCategory,
  CreateUserCustomAppCategoryDto,
  UpdateUserCustomAppCategoryDto,
} from '../types';

const BASE = '/my-custom-app-categories';

export const customAppCategoriesService = {
  getMyCategories: async (): Promise<UserCustomAppCategory[]> => {
    const response = await apiClient.get<ApiResponse<UserCustomAppCategory[]>>(BASE);
    return response.data.data;
  },

  create: async (dto: CreateUserCustomAppCategoryDto): Promise<UserCustomAppCategory> => {
    const response = await apiClient.post<ApiResponse<UserCustomAppCategory>>(BASE, dto);
    return response.data.data;
  },

  update: async (id: number, dto: UpdateUserCustomAppCategoryDto): Promise<UserCustomAppCategory> => {
    const response = await apiClient.patch<ApiResponse<UserCustomAppCategory>>(`${BASE}/${id}`, dto);
    return response.data.data;
  },

  delete: async (id: number): Promise<void> => {
    await apiClient.delete(`${BASE}/${id}`);
  },
};
